import { SelectChipControl } from "./SelectChipControl";
import { CarouselSelectControl } from "./CarouselSelectControl";
import { CheckboxControl } from "./CheckboxControl";
import { DropdownSelectControl } from "./DropdownSelectControl";
import { NumberInputControl } from "./NumberInputControl";
import { TileSelectControl } from "./TileSelectControl";
import { HeroControl } from "./HeroControl";
import { HorizontalCarouselControl } from "./HorizontalCarouselControl";
import { TabSelectControl } from "./TabSelectControl";
import { StaticImageSelectControl } from "./StaticImageSelectControl";
import type { ConfiguratorControlChange, ConfiguratorControlViewModel } from "./controlViewModel";

export interface ControlRendererProps {
  viewModel: ConfiguratorControlViewModel;
  onChange: (change: ConfiguratorControlChange) => void;
  appearance?: "default" | "carouselDetail";
}

export const ControlRenderer = ({ viewModel, onChange, appearance = "default" }: ControlRendererProps) => {
  const commit = (value: string | null) => onChange({ controlIndex: viewModel.controlIndex, value });

  switch (viewModel.type) {
    case "Hero":
      return <HeroControl {...viewModel} />;
    case "SelectChip":
      return <SelectChipControl {...viewModel} onChange={commit} />;
    case "TileSelect":
      return <TileSelectControl {...viewModel} onChange={commit} />;
    case "HorizontalCarousel":
      return <HorizontalCarouselControl {...viewModel} onChange={commit} />;
    case "DropdownSelect":
      return <DropdownSelectControl {...viewModel} appearance={appearance} onChange={commit} />;
    case "NumberInput":
      return <NumberInputControl {...viewModel} onChange={commit} />;
    case "CarouselSelect":
      return <CarouselSelectControl {...viewModel} onChange={commit} />;
    case "TabSelect":
      return <TabSelectControl {...viewModel} onChange={commit} />;
    case "StaticImageSelect":
      return <StaticImageSelectControl {...viewModel} onChange={commit} />;
    case "Checkbox":
      return <CheckboxControl {...viewModel} appearance={appearance} onChange={commit} />;
  }
};
